import React from 'react';

/**
 * 태그 시스템 섹션 컴포넌트
 */
function TagsSection() {
  return (
    <section id="tags" className="guide-section">
      <h2>🏷️ 태그 시스템</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>🏷️ 기본 태그</h3>
          <div className="feature-steps">
            <p><strong>제공되는 기본 태그:</strong></p>
            <div className="tag-examples">
              <span className="tag-example personal">개인</span>
              <span className="tag-example work">업무</span>
              <span className="tag-example social">소셜</span>
              <span className="tag-example financial">금융</span>
              <span className="tag-example shopping">쇼핑</span>
              <span className="tag-example gaming">게임</span>
              <span className="tag-example important">중요</span>
              <span className="tag-example temporary">임시</span>
            </div>
            
            <p><strong>사용 방법:</strong></p>
            <ul>
              <li>패스워드 추가/수정 시 태그 드롭다운 클릭</li>
              <li>원하는 태그 선택 (최대 10개)</li>
              <li>Enter 키로 빠른 추가</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>✏️ 커스텀 태그</h3>
          <div className="feature-steps">
            <p><strong>나만의 태그 만들기:</strong></p>
            <ol>
              <li>태그 입력란에 새로운 태그명 입력</li>
              <li>Enter 키로 추가</li>
              <li>자동으로 태그 목록에 저장</li>
              <li>다음에 드롭다운에서 선택 가능</li>
            </ol>
            
            <div className="example-box">
              <strong>예시:</strong><br/>
              "회사A", "프로젝트B", "개발", "디자인" 등
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>🔍 태그로 검색</h3>
          <div className="feature-steps">
            <p><strong>검색 방법:</strong></p>
            <ul>
              <li>검색창에 "#태그명" 입력</li>
              <li>해당 태그가 붙은 패스워드만 표시</li>
              <li>여러 태그 조합 검색 가능</li>
            </ul>
            
            <div className="example-box">
              <strong>예시:</strong><br/>
              "#업무" → 업무 관련 패스워드만 표시<br/>
              "#중요 #금융" → 중요하고 금융 관련 패스워드
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>🎯 태그 관리 팁</h3>
          <div className="feature-steps">
            <p><strong>효과적인 태그 사용법:</strong></p>
            <ul>
              <li>🏢 용도별: #업무, #개인, #학교</li>
              <li>🎯 중요도별: #중요, #임시, #백업</li>
              <li>📂 프로젝트별: #프로젝트A, #클라이언트B</li>
            </ul>
            
            <div className="tip-box">
              <strong>💡 권장:</strong> 5-10개 정도의 핵심 태그를 정해서 일관성 있게 사용하세요.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TagsSection;